export const BILLING_MANAGEMENT_LIST = "BILLING_MANAGEMENT_LIST"
export const BILLING_MANAGEMENT_DETAIL = "BILLING_MANAGEMENT_DETAIL"